import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {Loader, Segment} from 'semantic-ui-react';

import {Button, Modal} from '@components';
import paths from '@paths';
import * as handlers from './handlers';
import * as hooks from './hooks';
import {Props} from './types';

import './index.scss';

const Main: React.FC<Props> = props => {
  const [isLoading, setIsLoading] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [errorMessages, setErrorMessages] = useState('');
  const [isShowLink, setIsShowLink] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  hooks.useMount(props.me, props.history);
  return (
    <div className="a__csv-main">
      <div className="b__title">
        <Button.GoBack history={props.history} />
        ユーザーインポート・エクスポート
      </div>
      <div className="w__csv-import">
        <div className="w__forms">
          <div>
            <div className="w__field">
              <div className="b__csv">
                <div className="b__field sample">
                  <div className="b__field-title">サンプルCSVダウンロード</div>
                  <div className="b__field-content">
                    ユーザーインポートで利用できるサンプルCSVがダウンロードできます。
                    作成したCSVでインポートを行なってください。
                    <Button.Normal
                      text="サンプルCSVをダウンロードする"
                      color="yellow"
                      onClick={() => {
                        handlers.downloadSampleCsv(setIsDownloading);
                      }}
                      loading={isDownloading}
                      disabled={isLoading || isDownloading}
                      className="sample"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w__field-lower">
            <div className="w__field">
              <div className="b__csv">
                <div className="b__field">
                  <div className="b__field-title">ユーザーインポート</div>
                  <div className="b__field-content button">
                    ユーザーインポートではCSV形式でユーザーを一括登録することができます。
                    サンプルCSVから作成したデータを選択して、インポートしてください。
                    ユーザーの一括登録を行います。
                  </div>

                  <div className="b__field-content button">
                    <label>
                      <span>
                        {isLoading ? (
                          <Segment className="segment">
                            <Loader active size="tiny" />
                          </Segment>
                        ) : (
                          'ユーザーをインポートする'
                        )}
                      </span>

                      <input
                        type="file"
                        id="csv"
                        accept="text/csv"
                        onChange={(event: any) =>
                          handlers.upload(
                            event,
                            props.me,
                            setIsErrorModal,
                            setErrorMessages,
                            setIsShowLink,
                            setIsLoading,
                            props.actions
                          )
                        }
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="w__field">
              <div className="b__csv">
                <div className="b__field">
                  <div className="b__field-title">ユーザーエクスポート</div>
                  <div className="b__field-content">
                    ユーザーエクスポートでは、現在の登録しているユーザーをCSV形式で保存できます。
                    <Button.Normal
                      text="ユーザーをエクスポートする"
                      color="green"
                      onClick={() => {
                        handlers.downloadCsv(props.me.teamId, setIsExporting);
                      }}
                      className="margin-top"
                      disabled={isLoading || isExporting}
                      loading={isExporting}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w__link">
          ユーザーインポートに関する注意事項・ヘルプは
          <Link to={paths.csv.help}>
            <b>こちら</b>
          </Link>
          からご確認ください。
        </div>
      </div>
      <Modal.Normal
        isModal={isErrorModal}
        handleCloseModal={setIsErrorModal}
        title="ユーザー登録の失敗"
        size="sm"
        cancelText="閉じる"
        scroll
        type="error"
      >
        {isShowLink ? (
          <div>
            ユーザー登録上限数を超えている為、ユーザーのインポートが行えませんでした。
            <br />
            <Link to={paths.price.main}>プランを変更する</Link>
          </div>
        ) : (
          <div className="w__error-message">
            <div className="error_message">
              エラーが発生した為、ユーザーのインポートが行えませんでした。
            </div>
            <li className="b__list-content">{errorMessages}</li>
          </div>
        )}
      </Modal.Normal>
    </div>
  );
};

export default Main;
